import { findParentNode } from '@tiptap/core';
import { Plugin, PluginKey } from 'prosemirror-state';
import { Decoration, DecorationSet } from 'prosemirror-view';

export const CellSelectionDecorationPlugin = new Plugin({
  key: new PluginKey('cellSelectionDecoration'),
  props: {
    decorations(state) {
      const { selection } = state;
      if (!selection.empty) {
        return DecorationSet.empty;
      }
      const cell = findParentNode((node) => node.type.name === 'tableCell')(selection);
      if (cell) {
        return DecorationSet.create(state.doc, [
          Decoration.node(cell.pos, cell.pos + cell.node.nodeSize, {
            class: 'cell-selected',
          }),
        ]);
      }
      return DecorationSet.empty;
    },
  },
});

export default CellSelectionDecorationPlugin;
